import styled, { css } from "styled-components";
import {
  semanticAlertRedBgWeakest,
  semanticInfoBlueBgWeakest,
  semanticSuccessGreenBgWeakest,
} from "@songtradr/component-library";

// TEXT

// STYLES
export const StatusPill = styled.div<{ $status: string; $dynamic?: boolean }>(
  ({ $status, $dynamic }) => {
    const bgColor =
      $status === "Active"
        ? semanticSuccessGreenBgWeakest
        : $status === "Expiring" || $status === "Invited"
          ? semanticInfoBlueBgWeakest
          : semanticAlertRedBgWeakest;
    /** @todo need to remove the !important tag once component library table is updated */
    return css`
      display: flex !important;
      align-items: center;
      justify-content: center;
      width: ${$dynamic ? "auto" : "4rem"};
      padding: ${$dynamic ? "0.5rem 1rem" : "0"};
      height: 2rem;
      border-radius: 2.5rem;
      background: ${bgColor};
    `;
  },
);

// DATA

// TYPES

// CONSTANTS

// FUNCTIONS

// ASSETS
